import React from 'react';
import { Clock, Calendar } from 'lucide-react'; // optional icons
import UseGetDashBoardData from '../../../../Components/Hooks/useDashboardData';

function Refilling() {
  const { data, loading } = UseGetDashBoardData(`/dashboard/refilling-status`);
  const currentMonthYear = new Date().toLocaleString('default', { month: 'long', year: 'numeric' });

  return (
    // <div className="col-span-2 bg-white h-[50vh] 2xl:h-[54vh] w-full p-4 rounded-2xl shadow-lg  flex flex-col mb-2">
    <div className="col-span-2 bg-gradient-to-r from-white to-gray-50 h-[22vh]  w-full p-4 rounded-2xl shadow-lg  flex flex-col justify-between">
      
       <div className="flex justify-between items-center ">
       <h3 className="text-gray-700 text-sm font-semibold">Refilling Status</h3>

         <p className="text-gray-500  text-xs font-light">{currentMonthYear}</p>

      </div>

         <div className="flex gap-2 justify-around h-full w-full  scrollbar-thin scrollbar-thumb-gray-300 items-start my-1 2xl:my-2">
        
         <div className="bg-yellow-100 p-2 rounded-2xl shadow  w-[50%] border border-yellow-200 hover:shadow-md transition duration-200 h-16 2xl:h-20   flex flex-col justify-between">
          <div className="flex items-center justify-between ">
            <div className="flex items-center gap-1">
              <Clock size={12} className="text-yellow-700" />
              <h3 className="text-xs 2xl:text-sm font-semibold text-yellow-800">In Progress</h3>
            </div>
          </div>
          <div className="text-center">
            <p className="text-sm 2xl:text-xl font-extrabold text-yellow-900">{data?.in_progress}</p>
            <p className="text-xs text-yellow-700 ">Currently being refilled</p>
          </div>
        </div>

           <div className="bg-blue-100 p-2 rounded-2xl shadow border w-[50%] border-blue-200 hover:shadow-md transition duration-200 h-16 2xl:h-20   flex flex-col justify-between">
          <div className="flex items-center justify-between mb-1">
            <div className="flex items-center gap-1">
              <Calendar size={12} className="text-blue-700" />
              <h3 className="text-xs 2xl:text-sm font-semibold text-blue-800">Upcoming</h3>
            </div>
          </div>
          <div className="text-center">
            <p className="text-sm 2xl:text-xl font-extrabold text-blue-900">{data?.upcoming}</p>
            <p className="text-xs text-blue-700 ">To Be Scheduled</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Refilling;


